var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('CompareHeader'),_vm._v(" "),_c('CompareList',{staticClass:"mt-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }